<template>
    <div class="activity-card">
        <a :href="`/content/${content.slug}`" class="rfeed-article__link"></a>
        <div class="grid-row grid-row--smg">
            <div class="grid-col grid-col--auto" v-if="content.thumbnail_xs">
                <img
                    :src="content.thumbnail_xs"
                    :srcset="`${content.thumbnail_sm} 2x`"
                    width="108"
                    height="108"
                    alt=""
                    class="activity-card__image"
                />
            </div>
            <div class="grid-col">
                <div class="activity-card__head">
                    <div class="activity-card__badge">{{ content.content_type.name }}</div>
                    <div class="activity-card__meta">{{ renderFormDate(content.created_at) }}</div>

                    <template v-if="content.content_type.name === 'Video'">
                        <div class="rfeed-article__bull removed--xs"></div>
                        <div class="activity-card__meta removed--xs">
                            {{ videoDuration(content.settings.video_duration) }}
                        </div>
                    </template>

                    <button
                        type="button"
                        v-tooltip="`Discard`"
                        style="margin-left: auto"
                        class="activity-card__action activity-card__action--book"
                        :class="{
                            active:
                                guest &&
                                guest.resource_ids &&
                                guest.resource_ids.includes(content.id)
                        }"
                        @click="bookmarkAction(guest, content)"
                    ></button>

                    <v-popover popoverClass="share-popover" placement="top">
                        <button
                            type="button"
                            v-tooltip="`Share`"
                            class="activity-card__action activity-card__action--share"
                        ></button>

                        <template slot="popover">
                            <share :content="content" :url="shareUrl"></share>
                            <a v-close-popover class="close-popover">
                                <svg
                                    height="20px"
                                    viewBox="0 0 512 512"
                                    width="20px"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill="#666"
                                        d="m256 512c-141.160156 0-256-114.839844-256-256s114.839844-256 256-256 256 114.839844 256 256-114.839844 256-256 256zm0-475.429688c-120.992188 0-219.429688 98.4375-219.429688 219.429688s98.4375 219.429688 219.429688 219.429688 219.429688-98.4375 219.429688-219.429688-98.4375-219.429688-219.429688-219.429688zm0 0"
                                    />
                                    <path
                                        fill="#666"
                                        d="m347.429688 365.714844c-4.679688 0-9.359376-1.785156-12.929688-5.359375l-182.855469-182.855469c-7.144531-7.144531-7.144531-18.714844 0-25.855469 7.140625-7.140625 18.714844-7.144531 25.855469 0l182.855469 182.855469c7.144531 7.144531 7.144531 18.714844 0 25.855469-3.570313 3.574219-8.246094 5.359375-12.925781 5.359375zm0 0"
                                    />
                                    <path
                                        fill="#666"
                                        d="m164.570312 365.714844c-4.679687 0-9.355468-1.785156-12.925781-5.359375-7.144531-7.140625-7.144531-18.714844 0-25.855469l182.855469-182.855469c7.144531-7.144531 18.714844-7.144531 25.855469 0 7.140625 7.140625 7.144531 18.714844 0 25.855469l-182.855469 182.855469c-3.570312 3.574219-8.25 5.359375-12.929688 5.359375zm0 0"
                                    />
                                </svg>
                            </a>
                        </template>
                    </v-popover>
                </div>
                <h4 class="mt--075 activity-card__title">{{ content.title }}</h4>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Time from '../../../mixins/Time';
import collectorActions from '../../../mixins/collectorActions';
import bookmarkActions from '../../../mixins/bookmarkActions';
import discardActions from '../../../mixins/discardActions';

export default {
    name: 'settings-card',
    props: ['content'],
    mixins: [Time, collectorActions, bookmarkActions, discardActions],
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            guest: 'guest'
        }),
        shareUrl() {
            return window.location.origin + '/content/' + this.content.slug;
        }
    },
    methods: {},
    watch: {}
};
</script>

<style lang="scss"></style>
